import classnames from 'classnames';
import React from 'react';

interface InputLabelComponentProps {
  id: string;
  isCheckbox?: boolean;
  texts: {
    label: string;
    hint?: string | React.ReactNode;
  };
  disabled?: boolean;
  bolder?: boolean;
}

export const InputLabelComponent: React.FC<InputLabelComponentProps> = React.memo(
  ({ bolder = false, disabled, id, isCheckbox = false, texts }: InputLabelComponentProps) => (
    <label
      className={classnames('fr-label', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'fc-text--title-disabled-grey': disabled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'fr-h6 fr-mb-0': !isCheckbox,
      })}
      htmlFor={id}>
      {texts.label}
      {texts.hint && (
        <span
          className={classnames('fr-hint-text', {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'fc-text--no-bold': !bolder,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'fc-text--title-disabled-grey': disabled,
          })}>
          {texts.hint}
        </span>
      )}
    </label>
  ),
);

InputLabelComponent.displayName = 'InputLabelComponent';
